import { splitByChunks } from "@clearabee/ui-sdk";
import { GetRouteQuery } from "lib/routes";
import { postcode } from "lib/schemas";
import { z } from "zod";

export type QueryParams = GetRouteQuery<"ServicePage">;

export const queryToState = ({
  products,
  wasteType,
  type,
  ref,
  postcode,
  previousSkip,
}: QueryParams): FormState => {
  const chunks = splitByChunks((products ?? "").split(","), 2);
  const obj: Record<string, number> = {};

  for (const chunk of chunks) {
    const productSku = chunk[0];
    const quantity = Number(chunk[1]);

    if (!isNaN(quantity)) {
      obj[productSku] = quantity;
    }
  }

  return {
    product: null,
    exchange: null,
    wasteType: wasteType ?? "",
    wasteTypeAndPostcode: {
      wasteType: wasteType ?? "",
      postcode: postcode ?? "",
    },
    refAndPostcode: {
      ref: ref ?? "",
      postcode: postcode ?? "",
      previousSkip: previousSkip ?? "",
    },
    type: type as typeof skipTypes[number],
  };
};

export const stateToQuery = ({
  refAndPostcode,
  wasteTypeAndPostcode,
  wasteType,
  ...rest
}: FormState): QueryParams => {
  return {
    ...rest,
    ref: refAndPostcode?.ref,
    postcode: refAndPostcode?.postcode ?? wasteTypeAndPostcode?.postcode,
    wasteType: wasteType ?? wasteTypeAndPostcode?.wasteType,
    previousSkip: refAndPostcode?.previousSkip,
  };
};

export const skipTypes = ["SKIPEXCHANGE", "SKIPHIRE"] as const;

export const refAndPostcodeSchema = z.object({
  ref: z.string().min(1),
  postcode,
  previousSkip: z.string().optional(),
});

export const schema = z.object({
  type: z.enum(skipTypes).optional(),
  refAndPostcode: refAndPostcodeSchema.nullable(),
  wasteType: z.string().min(1),
  wasteTypeAndPostcode: z
    .object({
      wasteType: z.string().min(1),
      postcode,
    })
    .nullable(),
  product: z.string().nullable(),
  exchange: z.string().nullable(),
});

export type FormState = z.input<typeof schema>;
